module.exports = __webpack_public_path__ + "assets/facil.d71bd931a6ac87d0e1129634b6ce3673.png";


//////////////////
// WEBPACK FOOTER
// ./img/landingPage/facil.png
// module id = 882
// module chunks = 0